import { render, staticRenderFns } from "./OrganizationBackendComponent.vue?vue&type=template&id=7a3e5fec&scoped=true&"
import script from "./OrganizationBackendComponent.vue?vue&type=script&lang=js&"
export * from "./OrganizationBackendComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3e5fec",
  null
  
)

export default component.exports